import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    tarefa: {
        marginBottom: theme.spacing(3),

    },
    tarefaHover: {
        cursor: 'pointer',
        '&:hover': {
            '& span, & p': {
                color: theme.palette.primary.main,
            }
        },
    },
    tituloTarefa: {
        fontWeight: 700,
        color: theme.palette.text.primary,
    },
    infoTarefa: {
        display: 'flex',
        alignItems: 'center'
    },
    tpLog: {
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(.1, 1),
        marginRight: theme.spacing(.5),
        display: 'flex',
        height: '100%',
        alignItems: 'center',
    },
    tpLogTitulo: {
        color: theme.palette.common.white + '!important',
        fontSize: '.6rem',
        fontWeight: 600,
        lineHeight: 1.5,
        whiteSpace: 'nowrap',
    },
    card: {
        background: '#F8F8F8',
        padding: theme.spacing(1),
    },
    editIcon: {
        borderLeft: '2px solid #E6E6E6',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingLeft: '10px',
        marginLeft: '10px',
    }
}))